// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"94":"Login","561":"Dashboard"}[chunkId] || chunkId) + "." + {"41":"c359e7f5","94":"2e64f105","108":"4c92f56a","202":"2e39253a","453":"8e967287","561":"076feb06"}[chunkId] + ".chunk.js";
};